import React from 'react';
import { IoLocationSharp } from 'react-icons/io5';
import './Marker.scss';
const Marker = () => {
    return React.createElement(IoLocationSharp, { className: "map-marker" });
};
export default Marker;
